import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import * as RetornoHttp from '../../../../services/api/https/deliveries/retorno.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  CustomPanel,
  ImageContainer,
  Loading,
  PageHeader,
  UploadFileBtn,
} from '../../../../components'
import { urlUploadCanhoto } from '../../../../services/api/routes/receive-vehicle.routes'
import { getDelivery } from '../../../../services/api/https/deliveries/delivery.http'

function Canhoto({ history, dispatch }) {
  // Vars
  const {
    location: {
      state: { delivery_id, returnTo },
    },
  } = history

  const handleVoltar = () => {
    if (returnTo) {
      history.push(returnTo.path, { restoreModal: returnTo })
    } else {
      history.goBack()
    }
  }

  // Hooks
  const [entrega, setEntrega] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    getEntrega()
  }, [delivery_id])

  // Events
  const onUploadCompleted = async file_name => {
    try {
      await RetornoHttp.putUpdateDeliveryPaths(delivery_id, 'canhoto', file_name)
      await getEntrega()
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }
  const onDeleteCanhotoClicked = async () => {
    try {
      const path_array = entrega.path_canhoto.split('/')
      const file_name = path_array[path_array.length - 1]
      await RetornoHttp.deleteDeliveryCanhotoFile(file_name)
      await RetornoHttp.putUpdateDeliveryPaths(delivery_id, 'canhoto', null)
      setEntrega({ ...entrega, path_canhoto: null })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  // Helper
  const getEntrega = async () => {
    try {
      if (!delivery_id) throw new Error('Volte na tela anterior para selecionar a Entrega desejada')
      const fetchedEntrega = await getDelivery(delivery_id)
      setEntrega(fetchedEntrega)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return (
    <React.Fragment>
      <PageHeader>
        Anexar Canhoto &nbsp;
        <strong>{entrega ? `${entrega.nome_fantasia} - ${entrega.identifier}` : ''}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={handleVoltar}>
          <div className="p-grid">
            {!isLoading && !entrega.path_canhoto && (
              <div className="p-col-2" style={{ height: 50 }}>
                <UploadFileBtn
                  label="Anexar Canhoto"
                  name="canhoto"
                  url={urlUploadCanhoto(delivery_id)}
                  onUploadCompleted={onUploadCompleted}
                />
              </div>
            )}
            <div className="p-col-12">
              {isLoading ? (
                <div className="text-center">
                  <Loading />
                </div>
              ) : entrega.path_canhoto ? (
                <ImageContainer
                  imagePath={entrega.path_canhoto}
                  alt="Canhoto"
                  onBtnDeleteClicked={onDeleteCanhotoClicked}
                />
              ) : null}
            </div>
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

export default connect()(withRouter(Canhoto))
